<template>
    <file-manager-modal
            v-if="show"
            :size="size"
            :show="show"
            file-manager-modal-close="close()">

        <div class="modal-header">
            <h4 class="modal-title">{{ t.__('Przenieś element') }}</h4>
            <button type="button" class="close" @click="close()"><span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body">
            <div class="form-group">
                <label>{{ t.__('Nazwa elementu') }}</label>
                <p class="static">{{ getItemName(currentFile) }}</p>
            </div>
            <div class="form-group">
                <label for="newFolderLocation">{{ t.__('Przenieś do') }}</label>
                <select id="newFolderLocation"
                        ref="newFolderLocation"
                        v-model="newFolderLocation"
                        class="form-control"
                        name="newFolderLocation"
                        @keyup.enter="moveItem()">
                    <option v-for="directory in allDirectories" :key="directory.path" :value="directory.path" :disabled="!directory.write_access" v-html="directory.name"></option>
                </select>
            </div>

            <file-manager-errors :errors="errors"/>
        </div>

        <div class="modal-footer">
            <button class="btn btn-primary"
                    type="button"
                    @click="moveItem()">
                <template v-if="loading">{{ t.__('Przenoszę...') }}</template>
                <template v-if="!loading">{{ t.__('Przenieś') }}</template>
            </button>
            <button class="btn btn-light"
                    type="button"
                    @click="close()">
                {{ t.__('Anuluj') }}
            </button>
        </div>

    </file-manager-modal>
</template>

<script>

    import axios from "axios";
    import fileManagerMixin from "../../mixins/file-manager-mixin";
    import FileManagerErrors from "./FileManagerErrors";

    export default {
        components: {
            'file-manager-errors': FileManagerErrors,
        },

        mixins: [fileManagerMixin],

        props: {
            currentPath: {
                default: '',
                type: String
            },
            currentFile: {
                default: function () {
                    return {};
                },
                type: [Object, Boolean]
            },
            show: {
                default: false,
                type: Boolean
            }
        },

        data() {
            return {
                allDirectories: {},
                errors: [],
                newFolderLocation: null,
                loading: false,
                size: 'modal-sm'
            };
        },

        watch: {
            show(open) {
                if (open) {
                    this.open();
                }
            }
        },

        mounted() {
            document.addEventListener('keydown', (e) => {
                if (this.show && e.keyCode === 13) {
                    this.moveItem();
                }
            });
        },

        methods: {
            close() {
                this.newFolderName = null;
                this.loading = false;
                this.$emit('file-manager-modal-close');
            },

            open() {
                axios.get(route('file-manager.directories')).then(
                    (response) => {
                        this.newFolderLocation = this.currentPath;
                        this.allDirectories = response.data.data;
                    },
                    (response) => {
                        const error = response.data.message;
                        this.fileManagerNotify(error, 'danger');
                    }
                );
                window.Vue.nextTick(() => {
                    this.$refs.newFolderLocation.focus();
                });
            },

            moveItem() {

                const data = {
                    'path': this.currentPath,
                    'file_name': this.getItemName(this.currentFile),
                    'new_path': this.newFolderLocation,
                    'type': (this.isFolder(this.currentFile)) ? 'Folder' : 'File'
                };

                this.loading = true;
                axios.post(route('file-manager.move'), data).then(
                    (response) => {
                        this.$emit('reload-folder');
                        window.eventHub.$emit('file-manager-notification', response.data.success);
                        this.close();
                    }).catch((error) => {
                    this.errors = (error.response.data.error) ? error.response.data.error : error.response.statusText;
                    this.loading = false;
                });
            }
        }
    };
</script>
